import { Fragment } from "react";
import { Dialog, Transition, TransitionChild } from "@headlessui/react";
import { X } from "lucide-react";

type ImageLightboxProps = {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string | null;
  alt?: string;
};

export function ImageLightbox({
  isOpen,
  onClose,
  imageUrl,
  alt = "Imagen",
}: ImageLightboxProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm"
            aria-hidden
            onClick={onClose}
          />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto p-4">
          <div className="flex min-h-full items-center justify-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="relative w-full max-w-4xl transform"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  onClick={onClose}
                  className="absolute -top-2 -right-2 z-10 rounded-full bg-white/90 dark:bg-zinc-800 p-2 text-slate-600 dark:text-slate-300 shadow-lg hover:bg-white dark:hover:bg-zinc-700 transition-colors"
                  aria-label="Cerrar"
                >
                  <X className="h-5 w-5" />
                </button>
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={alt}
                    className="w-full h-auto max-h-[85vh] object-contain rounded-lg shadow-2xl"
                    draggable={false}
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center gap-3 rounded-lg bg-slate-800/50 dark:bg-zinc-900/80 py-16 px-8 text-slate-400">
                    <p className="text-sm">No hay imagen para mostrar</p>
                  </div>
                )}
              </Dialog.Panel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
